import React from "react";
import styles from "./Button2.module.css";

const Button2 = ({ text, onClick, style }) => {
  return (
    <button style={style} className={styles.btn} onClick={onClick}>
      {text}
    </button>
  );
};

export default Button2;